// Same play/pause behaviour as the Video Slider block: the .play-button
// itself has pointer-events: none (see SCSS), so clicks land on the <video>
// underneath. Native HTML5 playback, no external player library.
document.querySelectorAll('.metamorphosis-film__figure video').forEach(function (video) {
    video.addEventListener('click', function () {
        const figure = video.closest('.metamorphosis-film__figure');
        if (!figure || (!video.paused && figure.classList.contains('playing'))) {
            return;
        }

        setTimeout(function () {
            video.play();
        }, 10);
        figure.classList.add('playing', 'played');
        video.setAttribute('controls', true);
    });
});
